import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAuditsStore = defineStore('audits', () => {
    const auditedModels = ref<Record<string, { label: string; value: string }>>(
        {
            platform: { label: 'Platform', value: 'App\\Models\\Platform' },
            natural_profile: {
                label: 'Natural Profile',
                value: 'App\\Models\\NaturalProfile',
            },
            legal_profile: {
                label: 'Legal Profile',
                value: 'App\\Models\\LegalProfile',
            },
            asset: { label: 'Asset', value: 'App\\Models\\Asset' },
            campaign: { label: 'Campaign', value: 'App\\Models\\Campaign' },
            order: { label: 'Order', value: 'App\\Models\\Order' },
            tax: { label: 'Tax', value: 'App\\Models\\Tax' },
            contract: { label: 'Contract', value: 'App\\Models\\Contract' },
            issuer: { label: 'Issuer', value: 'App\\Models\\Issuer' },
            payment_account: {
                label: 'PaymentAccount',
                value: 'App\\Models\\Payment\\PaymentAccount',
            },
            bank_account: {
                label: 'Bank Account',
                value: 'App\\Models\\BankAccount',
            },
        }
    )

    const auditEvents = ref<{ label: string; value: string }[]>([
        { label: 'Created', value: 'created' },
        { label: 'Updated', value: 'updated' },
        { label: 'Deleted', value: 'deleted' },
        { label: 'Restored', value: 'restored' },
    ])

    return {
        auditedModels,
        auditEvents,
    }
})
